import { Controller } from '@hotwired/stimulus';
import consumer from '../channels/consumer';

// Subscribes to the template's ActionCable stream and reloads the embedded PDF
// iframe whenever the template changes, so the preview stays in sync with edits.
// Attach to the iframe: data-controller="template-channel"
//                       data-template-channel-template-id-value="<id>"
export default class extends Controller {
  static values = { templateId: String };

  connect() {
    if (!this.templateIdValue) return;

    this.subscription = consumer.subscriptions.create(
      { channel: 'TemplateChannel', template_id: this.templateIdValue },
      { received: () => this.reload() },
    );
  }

  disconnect() {
    if (this.subscription) consumer.subscriptions.remove(this.subscription);
  }

  reload() {
    // Reassigning src forces the browser to re-fetch the regenerated PDF.
    this.element.src = this.element.src;
  }
}
